import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { postPortfolioPlanArchive } from "../request/postPortfolioPlanArchive";
import { portfolioPlanByIdKeyMaker } from "./useGetPortfolioPlanById";
import { portfolioPlanKeyMaker } from "./useGetPortfolioPlans";
const IDEMPOTENCY_DESCRIPTOR = "PortfolioPlan:Archive:";
export default function usePostPortfolioPlanArchive(config) {
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (portfolioPlanId) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return postPortfolioPlanArchive(portfolioPlanId, idempotencyKey, config);
        },
        onSuccess: (_, portfolioPlanId) => {
            // invalidate the cache for the portfolio plan by id
            queryClient.invalidateQueries({
                queryKey: portfolioPlanByIdKeyMaker(portfolioPlanId, null),
            });
            // invalidate the cache for the portfolio plans
            queryClient.invalidateQueries({
                queryKey: portfolioPlanKeyMaker(null),
            });
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=usePostPortfolioPlanArchive.js.map